var exports = {
  "iE": "x28a7bf27--2bd277--wrapper",
  "kL": "x28a7bf27--2bd277--container",
  "Qs": "x28a7bf27--2bd277--content",
  "wm": "x28a7bf27--2bd277--logo",
  "Qq": "x28a7bf27--2bd277--text",
  "Zd": "x28a7bf27--2bd277--form",
};

module.exports = exports;
